import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import type { SendTestNotificationDto } from '@/generated/korza-api-client/types.gen';
import { testNotificationsControllerSendTestNotification } from '@/generated/korza-api-client';
import { useTenant } from '@/hooks/use-tenant';
import { useI18nContext } from '@/i18n/i18n-react';
import { getApiErrorMessage } from '@/lib/api-error';

/**
 * Sends the test push to the admin's linked device (PUSH-08 AC 2). Generated
 * client without `throwOnError` (AD-025): a failure rejects with the body's
 * `message` (e.g. "No test device registered").
 */
export function useSendTestNotification(): UseMutationResult<
  void,
  Error,
  SendTestNotificationDto
> {
  const tenant = useTenant();
  const { LL } = useI18nContext();

  return useMutation<void, Error, SendTestNotificationDto>({
    mutationFn: async (body) => {
      const result = await testNotificationsControllerSendTestNotification({
        path: { tenantSlug: tenant.slug },
        body,
      });
      const { status } = result.response;
      if (status < 200 || status >= 300) {
        throw new Error(
          getApiErrorMessage(
            result.error,
            LL.campaignComposer.testDevice.sendError()
          )
        );
      }
    },
  });
}
